import { render, staticRenderFns } from "./a-link.vue?vue&type=template&id=276745ea&"
import script from "./a-link.vue?vue&type=script&lang=js&"
export * from "./a-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports